// extracted by mini-css-extract-plugin
export default {"root":"storageStatus_root__0gwP3","progress":"storageStatus_progress__SawQ4","usageText":"storageStatus_usageText__jGcNh"};